export default "https://cdn-static.gokick.com/assets/76516c8a60965c2814adf9f2d5cc0638cda6ee5d/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";